/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateFileDestroyPathParams, CandidateFileDestroyResponse } from '../types/CandidateFileDestroy'

/**
 * DELETE /candidates/:candidateId/files/:fileId
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateFileController.php CandidateFileController::destroy
 */
export async function candidateFileDestroy(
	candidateId: CandidateFileDestroyPathParams['candidateId'],
	fileId: CandidateFileDestroyPathParams['fileId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateFileDestroyResponse>> {
	return axiosInstance.delete(`/candidates/${candidateId}/files/${fileId}`, config)
}
